import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
// import { CloseIcon } from "../../../components/Icons";
import {
  CREATE_BOOKING_TYPE,
  DRAWERS,
  MODALS,
  WELLNESS_RENEWAL_ENTRY_POINTS,
  wellnessSubCatgories,
} from "../../../config/params";
import { DrawerNavbar, LayoutDrawer } from "../../../components";
import React, { useEffect, useLayoutEffect, useMemo, useState } from "react";
import { useBookingAppointmentTypeStore, useCombinedAlertsDataStore } from "../../../hooks";
import { useDispatch, useSelector } from "react-redux";

import { CATEGORIES_LIST } from "../PetCareContainer/CategoriesPanel";
import { IAppointmentDetails } from "../../../services/appointment-list/appointment-list.interface";
import { INoticationListState } from "../../../state/notifications";
import { IPetItemResponse } from "../../../services/pet-list/pet-list.interface";
import { IPetState } from "../../../state/pet";
import { IRootState } from "../../../state";
import LatestNotification from "./LatestNotification";
import { MIXPANEL_EVENTS } from "../../../config/mixPanelEvents";
import { Notification } from "../../../services/notifications/notifications-interface";
import { NotificationFeedEntry, sortFeedEntries } from "./notification-feed";
import { PAGES_PATH } from "../../../navigation/params";
import PastNotification from "./PastNotification";
import { useBraze } from "../../../context/BrazeContext";
import { toastMessageActions } from "../../../state/request";
import { useAppointmentStore } from "../../../hooks/redux-hooks/appointment-store/appointment.store";
import { useDashboard } from "../../../services/dashboard/dashboard.service";
import { useDrawer } from "../../../context/DrawerContext";
import { useGTM } from "../../../hooks/useGTM";
import { useModal } from "../../../context/ModalContext";
import { useNavigate } from "react-router-dom";
import { useOverdueInvoiceStore } from "../../../hooks/redux-hooks/overdue-invoice-store/overdue-invoice.store";
import { usePetList } from "../../../services/pet-list/pet-list.service";
import { useReadAllNotification } from "../../../services/notification-read/notification-read-all.service";
import { useSingleReadnotification } from "../../../services/notification-read/notification-read-single.service";
import { useUserStore } from "../../../hooks/redux-hooks/user-store/user.store";
import { userActivityLogger } from "../../../utils/mixpanel";
import useWellnessPlans from "../../../hooks/useWellnessPlans";
import useWellnessPurchaseData from "../../../hooks/redux-hooks/wellness-purchase-store/wellness-purchase-store";

export const CTA_ACTIONS = {
  BOOKAVISIT: "bookAVisit",
  BOOKAVISITWITHPETSELECTED: "bookAVisitWithPetSelected",
  PHONELOGINREMINDER: "phoneLogin",
  CUSTOMERREVIEW: "customerReview",
  CONTACTHOSPITAL: "contactHospital",
  PAYINVOICE: "payInvoice",
  EXPRESSVISIT: "openExpressVisit",
  UPDATEEXPIREDCARD: "updateCard",
  RENEWPLAN: "renewPlan",
  MANAGEPLAN: "managePlan",
  PAYNOW: "payNow",
  UPDATEPAYMENTMETHOD: "updatePaymentMethod",
  SUBSCRIBE: "subscribe",
  SEEPLAN: "seePlan",
  ADDPAYMENTMETHOD: "addPaymentMethod",
  BOOKNOW: "bookNow",
  REFERFRIEND: "referFriend",
  REFERNOW: "referNow",
  REVIEWNEWPLANS: "reviewNewPlans",
};

export const NOTIFICATIONSUBCATEGORY = {
  FIRSTPETADDED: "firstPetAdded",
  UPDATEHOSPITAL: "updateHospital",
  PETBIRTHDAYREMINDER: "petBirthdayReminder",
  PHONELOGINREMINDER: "phoneLoginReminder",
  SOCREMINDER: "socReminder",
  APPOINTMENTCOMPLETE: "appointmentComplete",
  FAILEDINVOICE: "failedInvoice",
  REFERRALREMINDER: "ReferralReminder",
  MOVINGPLAN: "movingPlan",
  SCRATCHPAYRENEWALREMINDER1DAYAFTER: "scratchpayRenewalReminder1DayAfter",
  SCRATCHPAY_OVERDUE_STARTED: "scratchpayOverdueStarted",
  SCRATCHPAY_DELINQUENCY_STARTED: "scratchpayDelinquencyStarted",
  SCRATCHPAY_PAYMENT_REINSTATED: "scratchpayPaymentReinstated",
};

const NotificationContainer = () => {
  const { closeDrawer } = useDrawer();
  const { openModal } = useModal();
  const { user } = useUserStore();
  const { cards: brazeCards, logImpression: logCardImpression, logClick: logCardClick,
    markAllViewed: markAllBrazeViewed } = useBraze();
  const { notificationsLists } = useSelector((state: IRootState) => state.notications as INoticationListState);
  const [showPastNotifications, setShowPastNotifications] = useState(false);
  const [localLatestNotifications, setLocalLatestNotifications] = useState<any>([]);
  const [localPastNotifications, setLocalPastNotifications] = useState<any>([]);
  const { dispatchEvent } = useGTM();
  const { setAppointmentsForm, setSelectedPets } = useAppointmentStore();
  const { petList } = useSelector((state: IRootState) => state.pet as IPetState);
  const { readNotification: readNotificationApi, error } = useSingleReadnotification();
  const { readAllNotification } = useReadAllNotification();
  const theme = useTheme();
  const mobileSize = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();
  const { getDashBoardData, dashboard } = useDashboard();
  const [pastAppointments, setPastAppointments] = useState<IAppointmentDetails[]>([]);
  const { setAppointmentDetails } = useAppointmentStore();
  const dispatch = useDispatch();
  const { pendingPaymentPetList, isBookingBlocked, pausedWellnessPetList, cancelledWellnessPetList }=
  useOverdueInvoiceStore();
  const { bookingAppointmentType } = useBookingAppointmentTypeStore();
  const { petsActive } = usePetList();
  const { scratchpayRenewalPending } = useCombinedAlertsDataStore();
  const { fetchCatalogItems, getPlanDataByScratchpayPlanId } = useWellnessPlans();
  const { setWellnessPurchaseData } = useWellnessPurchaseData();

  useEffect(()=>{
    getDashBoardData();
  }, []);

  useEffect(() => {
    if (scratchpayRenewalPending && scratchpayRenewalPending.length > 0) {
      scratchpayRenewalPending.forEach((renewal) => {
        fetchCatalogItems(renewal.petId);
      });
    }
  }, [scratchpayRenewalPending, fetchCatalogItems]);

  useEffect(()=>{
    let pastAppointmentList:IAppointmentDetails[] = [];

    if (dashboard && dashboard?.pastAppointments?.length > 0) {
      pastAppointmentList = dashboard.pastAppointments;
    }

    setPastAppointments(pastAppointmentList);
  }, [dashboard]);

  const handleCancel = () => {
    closeDrawer();
  };
  const handlePastNotifications = () => {
    userActivityLogger(MIXPANEL_EVENTS.SHOW_PAST_NOTI,
      {});
    setShowPastNotifications(!showPastNotifications);
  };

  const handleNotificationRead = () => {
    userActivityLogger(MIXPANEL_EVENTS.ALL_NOTI_MARK_READ, {});
    readAllNotification();
    // Also mark Braze content cards viewed so the badge clears for cards that
    // are below the fold (the per-card observer only marks visible ones).
    markAllBrazeViewed();
  };

  const handleGoToBookAVisit = (notification: Notification) => {
    if (notification.subCategory == "updateHospital") {
      userActivityLogger(MIXPANEL_EVENTS.BOOK_A_VISIT, {
        start_from: "update_hospital_notification",
        appt_type: bookingAppointmentType === CREATE_BOOKING_TYPE.DROPOFF_BOOKING ? "drop_off" : "in_room_visit",
        overdue_status: pendingPaymentPetList.length > 0 ? "yes" : "no",
        is_plan_cancelled: cancelledWellnessPetList.length > 0 ? "true" : "false",
      });
    }
    setAppointmentsForm(null);
    setSelectedPets([]);
    if (petsActive?.length==1) {
      setSelectedPets(petsActive);
    }
    // openDrawer(DRAWERS.BOOK_A_VISIT);
    if (!isBookingBlocked && (pendingPaymentPetList.length > 0)) {
      if (cancelledWellnessPetList.length > 0) {
        openModal(MODALS.PENDING_INVOICE_CANCELLED_ALERT_MODAL);
      } else if (pausedWellnessPetList.length > 0) {
        openModal(MODALS.PENDING_INVOICE_PAUSED_ALERT_MODAL);
      } else {
        openModal(MODALS.GENERIC_PAYMENT_ISSUE_MODAL);
      }
    } else {
      openModal(MODALS.UPDATED_BOOK_A_VISIT_MODAL);
    }
    handleCancel();
    dispatchEvent({
      eventName: "gv_book_a_visit_button_sidebar",
    });
  };

  const handleCustomerReview = (appointmentId: string, petId: string | null) => {
    let reviewAppointment:IAppointmentDetails[] = [];
    let petDetails: IPetItemResponse[] = [];

    petDetails = petList ? petList?.filter((pet)=>pet.id === petId) : [];

    if (petDetails.length === 0) {
      dispatch(toastMessageActions.setGlobalAlert({
        severity: "success",
        message: "Pet has been retired",
        customIcon: "info",
      }));
    } else {
      if (pastAppointments.length > 0) {
        reviewAppointment = pastAppointments.filter((appointment)=>appointment.id===appointmentId);
        if (reviewAppointment[0].feedback.length > 0) {
          dispatch(toastMessageActions.setGlobalAlert({
            severity: "success",
            message: "Feedback already submitted",
          }));
        } else if (!reviewAppointment[0].underFeedbackDays) {
          dispatch(toastMessageActions.setGlobalAlert({
            severity: "success",
            message: "Feedback submission period expired",
            customIcon: "info",
          }));
        } else {
          setAppointmentDetails(reviewAppointment[0]);
          openModal(MODALS.RATING_REVIEW_MODAL);
        }
      }
    }
  };

  const handleOpenSchedule = (petData: IPetItemResponse) => {
    closeDrawer(DRAWERS.VISIT_SCHEDULE);
    if (!isBookingBlocked && (pendingPaymentPetList.length > 0)) {
      if (pausedWellnessPetList.length > 0) {
        openModal(MODALS.PENDING_INVOICE_PAUSED_ALERT_MODAL);
      } else if (cancelledWellnessPetList.length > 0) {
        openModal(MODALS.PENDING_INVOICE_CANCELLED_ALERT_MODAL);
      } else {
        openModal(MODALS.GENERIC_PAYMENT_ISSUE_MODAL);
      }
    } else {
      userActivityLogger(MIXPANEL_EVENTS.BOOK_A_VISIT_SELECT_PET, {
        no_of_pets: 1,
        owner_type: petsActive?.length == 1 ? "single_pet" : "multipet",
        referred_from: "new_pet_notification",
        pet_name: petData.name,
        appt_type:
              bookingAppointmentType === CREATE_BOOKING_TYPE.DROPOFF_BOOKING ?
                "drop_off" :
                "in_room_visit",
      });
      openModal(MODALS.UPDATED_BOOK_A_VISIT_MODAL);
    }
    dispatchEvent({
      eventName: "gv_book_a_visit_select_pet_next",
      eventProps: {
        petQuantity: 1,
      },
    });
  };

  const handleExpressVisitCta = (petId: string | null) => {
    userActivityLogger(MIXPANEL_EVENTS.EXPRESS_SERVICE_SELECTED, {
      appointment_category: "tech", referred_from_page: "notification",
    });
    let petDetails: IPetItemResponse[] = [];

    petDetails = petList ? petList?.filter((pet)=>pet.id === petId) : [];

    if (petDetails.length) {
      petDetails[0]?.isEligibleForExpressVisit && setSelectedPets(petDetails);
      if (!isBookingBlocked && (pendingPaymentPetList.length > 0)) {
        if (cancelledWellnessPetList.length > 0) {
          openModal(MODALS.PENDING_INVOICE_CANCELLED_ALERT_MODAL);
        } else if (pausedWellnessPetList.length > 0) {
          openModal(MODALS.PENDING_INVOICE_PAUSED_ALERT_MODAL);
        } else {
          openModal(MODALS.GENERIC_PAYMENT_ISSUE_MODAL);
        }
      } else {
        openModal(MODALS.EXPRESS_VISIT_MODAL);
      }
    }

    closeDrawer();
  };

  const logWellnessAlertEvents = (notification: Notification) => {
    if (wellnessSubCatgories.includes(notification.subCategory)) {
      userActivityLogger(MIXPANEL_EVENTS.NOTIFICATION_CTA_CLICK, {
        notification_type: notification.subCategory,
        cta_title: notification.ctaName,
        notification_status: notification.status,
      });
    }
  };

  const logDeliquencyEvents = (notification: Notification) => {
    if (notification.subCategory === "failedInvoice") {
      const typeWithDeliquency = notification.ctaName === "contactHospital" ? "wp_cancelled" : "wp_paused";

      userActivityLogger(MIXPANEL_EVENTS.NOTIFICATION_CTA_CLICK, {
        notification_type: typeWithDeliquency,
        cta_title: notification.ctaName,
        notification_status: notification.status,
      });
    }
  };
  const handleCTA = (notification: Notification) => {
    logWellnessAlertEvents(notification);
    logDeliquencyEvents(notification);
    if (notification.subCategory == "firstPetAdded") {
      userActivityLogger(MIXPANEL_EVENTS.NOTIFICATION_CTA_CLICK, {
        notification_type: notification.subCategory,
        cta_title: `Book a visit for ${notification.ctaData.petName}`,
        notification_status: notification.status,
        location: user?.location?.locationName,
        msa: user?.location?.city,
      });
    } else if (notification.subCategory =="updateHospital") {
      userActivityLogger(MIXPANEL_EVENTS.NOTIFICATION_CTA_CLICK, {
        notification_type: notification.subCategory,
        cta_title: "Come meet the team!",
        notification_status: notification.status,
        location: user?.location?.locationName,
        msa: user?.location?.city,
      });
    } else if (notification.subCategory == "ReferralReminder") {
      navigate(PAGES_PATH.REFER_FRIEND);
    }
    if (notification.ctaName === CTA_ACTIONS.BOOKAVISITWITHPETSELECTED) {
      if (notification.subCategory==NOTIFICATIONSUBCATEGORY.SOCREMINDER) {
        userActivityLogger(MIXPANEL_EVENTS.BOOK_A_VISIT, {
          start_from: "socReminder",
          appt_type: bookingAppointmentType === CREATE_BOOKING_TYPE.DROPOFF_BOOKING ? "drop_off" : "in_room_visit",
          overdue_status: pendingPaymentPetList.length > 0 ? "yes" : "no",
          is_plan_cancelled: cancelledWellnessPetList.length > 0 ? "true" : "false",
        });
      } else {
        userActivityLogger(MIXPANEL_EVENTS.BOOK_A_VISIT, {
          start_from: "new_pet_notification",
          appt_type: bookingAppointmentType === CREATE_BOOKING_TYPE.DROPOFF_BOOKING ? "drop_off" : "in_room_visit",
          overdue_status: pendingPaymentPetList.length > 0 ? "yes" : "no",
          is_plan_cancelled: cancelledWellnessPetList.length > 0 ? "true" : "false",
        });
      }

      if (petList && petList?.length > 0) {
        const petData = petList.find((pet) => pet.id === notification.ctaData.petId);

        if (petData) {
          setSelectedPets([petData]);
          handleOpenSchedule(petData);

          return;
        }
      }

      dispatch(toastMessageActions.setGlobalAlert({
        severity: "success",
        message: "Pet has been retired",
        customIcon: "info",
      }));
    } else if (notification.ctaName === CTA_ACTIONS.PHONELOGINREMINDER) {
      userActivityLogger(MIXPANEL_EVENTS.NOTIFICATION_CTA_CLICK + "_phone_verification", {
        notification_type: notification.subCategory,
        notification_status: notification.status,
        cta_title: "Verify Now",
        origin: "In-app",
      });
      navigate(PAGES_PATH.EDIT_PROFILE);
    }
    if (notification.ctaName === CTA_ACTIONS.REFERFRIEND) {
      userActivityLogger(MIXPANEL_EVENTS.NOTIFICATION_CTA_CLICK, {
        notification_type: "refer_a_friend",
        notification_status: notification.status,
        cta_title: notification.ctaName,
        origin: "In-app",
      });
    }
    switch (notification.ctaName) {
    case CTA_ACTIONS.BOOKAVISIT:
    case CTA_ACTIONS.BOOKNOW:
      handleGoToBookAVisit(notification);
      break;
    case CTA_ACTIONS.CUSTOMERREVIEW:
      handleCustomerReview(notification.ctaData.appointmentId, notification.ctaData.petId);
      break;
    case CTA_ACTIONS.CONTACTHOSPITAL: openModal(MODALS.OVERDUE_CONTACT_MODAL);
      break;
    case CTA_ACTIONS.PAYINVOICE:
      navigate("/user-profile/payment");
      closeDrawer();
      break;
    case CTA_ACTIONS.EXPRESSVISIT:
      handleExpressVisitCta(notification.ctaData.petId);
      break;
    case CTA_ACTIONS.UPDATEEXPIREDCARD:
    case CTA_ACTIONS.RENEWPLAN:
    case CTA_ACTIONS.MANAGEPLAN:
    case CTA_ACTIONS.UPDATEPAYMENTMETHOD:
    case CTA_ACTIONS.SEEPLAN:
    case CTA_ACTIONS.ADDPAYMENTMETHOD:
      navigate(`${PAGES_PATH.MANAGE_PLAN}?id=${notification.ctaData.petId}`);
      break;
    case CTA_ACTIONS.PAYNOW:
      navigate(`${PAGES_PATH.USER_PROFILE}/${PAGES_PATH.USER_BILLING}`);
      break;
    case CTA_ACTIONS.SUBSCRIBE:
      navigate(`${PAGES_PATH.PET_CARE}?id=${notification.ctaData.petId}&category=${CATEGORIES_LIST[1].type}`);
      break;
    case CTA_ACTIONS.REFERFRIEND:
      navigate(PAGES_PATH.REFER_FRIEND);
      break;
    case CTA_ACTIONS.REVIEWNEWPLANS:
      // The generic "Review New Plans" renewal notification is no longer sent
      // by the backend, so the only REVIEWNEWPLANS CTA still in use is the
      // ScratchPay renewal reminder.
      if (notification.subCategory === NOTIFICATIONSUBCATEGORY.SCRATCHPAYRENEWALREMINDER1DAYAFTER) {
        handleScratchPayRenewalApplyNow(notification);
      }
      break;
    }
  };

  const handleScratchPayRenewalApplyNow = (notification: Notification) => {
    const petId = notification?.ctaData?.petId;
    if (!petId) {
      userActivityLogger(MIXPANEL_EVENTS.SCRATCHPAY_RENEWAL_APPLY_NOW_MISSING_PET_ID, {
        notification_type: notification.subCategory,
      });
    }
    const renewalData = scratchpayRenewalPending?.find((p) => p.petId === petId);

    if (renewalData) {
      // Track notification CTA click
      userActivityLogger(MIXPANEL_EVENTS.NOTIFICATION_CTA_CLICK, {
        notification_type: notification.subCategory,
        cta_title: "Apply Now with ScratchPay",
      });

      userActivityLogger(MIXPANEL_EVENTS.SCRATCHPAY_RENEWAL_APPLY_NOW_CLICKED, {
        pet_id: renewalData.petId,
        pet_name: renewalData.petName,
        plan_name: renewalData.planName,
        payment_method: "ScratchPay",
        entry_point: WELLNESS_RENEWAL_ENTRY_POINTS.SCRATCHPAY_RENEWAL_APPLY_NOW_CLICKED,
      });

      // Get plan data by scratchpayPlanId (catalog items already pre-fetched)
      const planData = getPlanDataByScratchpayPlanId(renewalData.scratchpayPlanId);

      if (planData) {
        // Set wellness purchase data with monthly billing pre-selected
        setWellnessPurchaseData({
          ...planData,
          scratchpayPlanId: renewalData.scratchpayPlanId,
          preferredBillingCycle: "perMonth",
          fromScratchPayRenewal: true,
        });
        // Navigate directly to payment page
        // eslint-disable-next-line max-len
        navigate(`${PAGES_PATH.WELLNESS_PLAN_DETAILS}${PAGES_PATH.WELLNESS_PLAN_CONFIRM_AND_PAY}?id=${petId}`);
        closeDrawer();
      } else {
        navigate(`${PAGES_PATH.WELLNESS_PLAN_DETAILS}?id=${petId}`);
        closeDrawer();
      }
    }
  };

  useEffect(()=>{
    setSelectedPets([]);
  }, []);

  const getNotificationIcon = (notification: Notification) => {
    let image;

    switch (notification.subCategory) {
    case NOTIFICATIONSUBCATEGORY.FIRSTPETADDED:
    case NOTIFICATIONSUBCATEGORY.PETBIRTHDAYREMINDER:
      if (notification.imageUrl) {
        image = notification.imageUrl;
      } else {
        image = "/assets/icons/dog_avatar.svg";
      }
      break;
    case NOTIFICATIONSUBCATEGORY.UPDATEHOSPITAL:
      if (notification.imageUrl) {
        image = notification.imageUrl;
      } else {
        image = "/assets/icons/hospital_icon.png";
      }
      break;
    case NOTIFICATIONSUBCATEGORY.PHONELOGINREMINDER:
      if (notification.imageUrl) {
        image = notification.imageUrl;
      } else {
        image = "/assets/icons/logo_horizontal_square_black.svg";
      }
      break;
    case NOTIFICATIONSUBCATEGORY.APPOINTMENTCOMPLETE:
      if (notification.imageUrl) {
        image = notification.imageUrl;
      } else {
        image = "/assets/icons/hospital_icon.png";
      }
      break;
    case NOTIFICATIONSUBCATEGORY.FAILEDINVOICE:
    case NOTIFICATIONSUBCATEGORY.SCRATCHPAY_OVERDUE_STARTED:
    case NOTIFICATIONSUBCATEGORY.SCRATCHPAY_DELINQUENCY_STARTED:
    case NOTIFICATIONSUBCATEGORY.SCRATCHPAY_PAYMENT_REINSTATED:
      if (notification.imageUrl) {
        image = notification.imageUrl;
      } else {
        image = "/goodvets-apple-touch-icon.png";
      }
      break;
    default:
      return "/assets/icons/user_frame.png";
    }

    return image;
  };

  // we will use only the local copy of notifications
  // when click on read filter out that and put it to past notifications
  // in the background as we click mark as read call that api also
  // handle case of mark as read for our local where api get's failed

  useLayoutEffect(()=>{
    const latestNotifications = notificationsLists?.notifications
      .filter((notification) => notification.status === "unread") || [];

    setLocalLatestNotifications(latestNotifications);

    const pastNotifications = notificationsLists?.notifications
      .filter((notification) => notification.status === "read") || [];

    setLocalPastNotifications(pastNotifications);
  }, [notificationsLists]);

  const handleSingleNotificationRead = (notificationId: string, notificationType:string) => {
    // ✅ MIXPANEL EVENT EXISTS: NOTI_MARK_READ
    // Tracks when user marks a single notification as read
    userActivityLogger(MIXPANEL_EVENTS.NOTI_MARK_READ, {
      notification_type: notificationType,
    });
    const readNotification = localLatestNotifications.find(
      (notification: Notification) => notification.notificationMessageId === notificationId,
    );

    if (readNotification) {
      const updatedNotification = { ...readNotification, status: "read" };

      setLocalPastNotifications([updatedNotification, ...localPastNotifications]);
    }

    const updatedLocalNotifications = localLatestNotifications.filter(
      (item: any) => item.notificationMessageId !== notificationId && item.status === "unread",
    );

    setLocalLatestNotifications(updatedLocalNotifications);
    readNotificationApi(notificationId);

    if (error) {
      console.error(error);
      // If the API call fails, reverting the changes to the local state
      setLocalLatestNotifications([readNotification, ...updatedLocalNotifications]);
      setLocalPastNotifications(localPastNotifications.filter((notification: Notification) =>
        notification.notificationMessageId !== notificationId));
    };
  };

  // Latest = unread backend notifications + active Braze content cards, pinned
  // cards floated to the top then newest-first. The Past section stays
  // backend-only (content cards have no read/unread lifecycle).
  const latestEntries = useMemo<NotificationFeedEntry[]>(() => {
    const backendEntries = (localLatestNotifications as Notification[]).map(
      (notification): NotificationFeedEntry => ({ kind: "backend", notification }),
    );
    const brazeEntries = brazeCards.map(
      (card): NotificationFeedEntry => ({ kind: "braze", card }),
    );

    return sortFeedEntries([...backendEntries, ...brazeEntries]);
  }, [localLatestNotifications, brazeCards]);


  return (
    <LayoutDrawer
      drawerNavbar={mobileSize ? (
        <DrawerNavbar onBack={handleCancel} ifIconClose={true} text={"Notifications"}>
          <Box sx={{ display: "flex", width: "100%", mx: "calc(100% - 48px)" }}>
          </Box>
        </DrawerNavbar>
      ) :
        <DrawerNavbar drawerNavbarStyle={{ background: "#FAF6F4" }}
          onBack={handleCancel} ifIconClose={true} text={"Notifications"}>
          <Box sx={{ display: "flex", width: "100%", mx: "calc(100% - 60px)" }}>
          </Box>
        </DrawerNavbar>}>
      <Box sx={{ display: "flex", flexDirection: "column", height: "100%", gap: "32px" }}>
        <LatestNotification
          entries={latestEntries}
          handleCTA={handleCTA}
          getIcon={getNotificationIcon}
          handleSingleNotificationRead={handleSingleNotificationRead}
          handleMarkAllRead={handleNotificationRead}
          logCardImpression={logCardImpression}
          logCardClick={logCardClick}
        />
        <Typography variant="body1" fontFamily="grenette-light-pro" textAlign="center"
          sx={{ cursor: "pointer" }} className="!capitalize" onClick={handlePastNotifications}>{showPastNotifications ?
            "Hide past notifications" : "Show past notifications"}</Typography>
        {showPastNotifications ? <PastNotification
          notifications={localPastNotifications}
          handleCTA={handleCTA}
          getIcon={getNotificationIcon}/> : null}
      </Box>
    </LayoutDrawer>
  );
};

export default NotificationContainer;

